/** @format */

import {SavedOrdersContext} from './saved_orders_context';
import {useFetch} from 'frontier-utilities';
import {useState, useEffect} from 'react';
import update from 'immutability-helper';
import React from 'react';

export function SavedOrdersProvider({children}) {
    const [hasMoreResults, setHasMoreResults] = useState(false);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [orders, setOrders] = useState([]);
    const [page, setPage] = useState(1);

    const {isLoading, fetchData} = useFetch(`/account/orders/saved/${page}`, response => {
        const updateTarget =
            page === 1 ? {$set: response.savedOrders} : {$push: response.savedOrders};
        setOrders(update(orders, updateTarget));
        setHasMoreResults(response.nextPage);
        setIsLoadingMore(false);
    });

    const handleRemove = orderId => {
        // remove order from the list state
        setOrders(currentOrders => {
            return currentOrders.filter(order => order.id !== orderId);
        });
    };

    async function handleRenameQuote(customLabel, orderId) {
        setOrders(currentOrders => {
            const orderIndex = currentOrders.findIndex(order => order.id === orderId);
            return update(currentOrders, {
                [orderIndex]: {
                    customer_label: {$set: customLabel}
                }
            });
        });
    }

    const handleLoadMore = () => {
        setPage(page + 1);
    };

    useEffect(() => {
        if (page === 1) return;
        setIsLoadingMore(true);
        fetchData();
    }, [page]);

    return (
        <SavedOrdersContext.Provider
            value={{
                isLoading: isLoading && !isLoadingMore,
                handleFetchOrders: fetchData,
                handleRenameQuote,
                handleLoadMore,
                hasMoreResults,
                isLoadingMore,
                handleRemove,
                orders
            }}>
            {children}
        </SavedOrdersContext.Provider>
    );
}

export function useSavedOrdersContext() {
    if (!SavedOrdersContext) {
        throw new Error('useSavedOrdersContext must be used within a SavedOrdersProvider');
    }

    return React.useContext(SavedOrdersContext);
}
